<script setup>

</script>

<template>
  <div>
    <h1>Reports Page</h1>
  </div>
</template>

<style scoped>

</style>